export class SystemDeviceInfo {
    constructor() {
        this.data = {
            model: null,
        };
        this.setData();
    }
    async setData() {
        if (!navigator.userAgentData ||
            !navigator.userAgentData.getHighEntropyValues) {
            return;
        }
        try {
            const externalData = await navigator.userAgentData.getHighEntropyValues([
                'model',
            ]);
            if (externalData.model) {
                this.data.model = externalData.model;
            }
        }
        catch (err) { }
    }
    get model() {
        return this.data.model;
    }
}
